module.exports = "label:hover, input[type=\"checkbox\"] {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/inputs/spk-checkbox/spk-checkbox.component.scss
// module id = ./src/app/components/framework/spk/inputs/spk-checkbox/spk-checkbox.component.scss
// module chunks = main